module.exports = __webpack_public_path__ + "static/reviews-8a8dbb6ec4d33e02ccd559846482b639.jpg";